import { Component, OnDestroy, OnInit } from '@angular/core';
import { StorageKeys } from '@core/constants';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { SessionStorageService } from '@core/services/session-storage/session-storage.service';
import { StorageService } from '@core/services/storage/storage.service';
import { Logout } from '@core/state/auth/auth.actions';
import { selectUserProfile } from '@core/state/userProfile/userProfile.selectors';
import { Store } from '@ngrx/store';
import { Button, ButtonLabel } from 'primeng/button';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IUserProfileModel } from 'src/app/modules/user-profile/features/user-profile-page/models/user-profile.model';

@Component({
  selector: 'au-impersonation-banner',
  templateUrl: './impersonation-banner.component.html',
  styleUrls: ['./impersonation-banner.component.scss'],
  imports: [Button, ButtonLabel],
})
export class ImpersonationBannerComponent implements OnInit, OnDestroy {
  userProfile$: Observable<IUserProfileModel | null>;
  userProfile: IUserProfileModel | null = null;
  destroyed$: Subject<void> = new Subject();

  get impersonate(): Boolean {
    return this.storageService.get<boolean>(StorageKeys.impersonation);
  }

  get centralCreateLabel(): Boolean {
    return this.sessionStorageService.get<boolean>(
      StorageKeys.centralCreateLabel
    );
  }

  get centralEditPickup(): Boolean {
    return this.sessionStorageService.get<boolean>(
      StorageKeys.centralEditPickup
    );
  }

  get centralConvertPickup(): Boolean {
    return this.sessionStorageService.get<boolean>(
      StorageKeys.centralConvertPickup
    );
  }

  constructor(
    private store: Store<any>,
    private storageService: StorageService,
    private sessionStorageService: SessionStorageService,
    private authenticationService: AuthenticationService
  ) {
    this.userProfile$ = this.store.select(selectUserProfile);
  }

  ngOnInit(): void {
    this.userProfile$.pipe(takeUntil(this.destroyed$)).subscribe((value) => {
      this.userProfile = value;
    });
  }

  stopImpersonation() {
    this.authenticationService
      .logout()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.store.dispatch(Logout());
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.unsubscribe();
  }
}
